module.exports = __webpack_public_path__ + "img/aiqiyi.43fecb42.jpeg";